/**
 * ANNI CUSTOM — Lob beim In-den-Warenkorb-Legen (H7).
 *
 * Kundenwunsch: Beim Klick auf „In den Warenkorb legen" wird der Kunde
 * gelobt („Sehr gute Wahl getroffen.").
 *
 * Banner IM Drawer-Inhalt (`[data-anni-praise]`), standardmäßig via CSS
 * zusammengeklappt (max-height 0). Beim Add Klasse `anni-praise--show` setzen.
 *
 * Knackpunkt: Dasselbe `cart:update`-Event morpht den Drawer und der Auto-Open
 * rendert ihn neu — beides ersetzt unser Banner und würde die Klasse
 * verschlucken. Statt fragiler Einzel-Timer/Observer halten wir die Klasse
 * einfach per Intervall für die volle Anzeigedauer aktiv (idempotent, übersteht
 * beliebig viele Morphs), danach räumen wir auf.
 *
 * Horizon feuert nach erfolgreichem Add ein CartAddEvent (Event-Name
 * `cart:update`) mit source `product-form-component` und ohne didError.
 */
const PRAISE_DURATION = 3500;
const TICK_INTERVAL = 100;

let showUntil = 0;
let ticker = null;

function now() {
  return typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();
}

function bannerInOpenDrawer() {
  return (
    document.querySelector('.cart-drawer__dialog[open] [data-anni-praise]') ||
    document.querySelector('[data-anni-praise]')
  );
}

function clearAll() {
  document
    .querySelectorAll('[data-anni-praise].anni-praise--show')
    .forEach((banner) => banner.classList.remove('anni-praise--show'));
}

function tick() {
  if (now() >= showUntil) {
    clearInterval(ticker);
    ticker = null;
    clearAll();
    return;
  }
  const banner = bannerInOpenDrawer();
  if (banner && !banner.classList.contains('anni-praise--show')) {
    banner.classList.add('anni-praise--show');
  }
}

function showPraise() {
  showUntil = now() + PRAISE_DURATION;
  if (!ticker) ticker = setInterval(tick, TICK_INTERVAL);
  tick();
}

document.addEventListener('cart:update', (event) => {
  const data = event.detail && event.detail.data;
  if (!data) return;
  if (data.source === 'product-form-component' && !data.didError) {
    showPraise();
  }
});
